<template>
    <div class="loginBG">
        <div class="contentbox">
            <div class="spBox">
                <div class="wordSyBox">
                    <div class="Words" v-if="itemsSyll[present].split_phons">
                    <span  v-for="(item,index) in itemsSyll[present].split_phons" :key="index"  :class="worIndex === index ? 'auto-fade-box' : ''"  wx:for-index="inde" :style="item.color == 'red' ?'color:#C55151':''">{{item.chars}}</span>
                    </div>
                </div>

                <div class="wordYb"  @click="wordYb(itemsSyll[present])" >
                    <span>[</span>
                    <span v-for="(item,index) in itemsSyll[present].phonics" :key="index" v-if="isPho" :style="item.color == 'red' ?'color:#C55151':''">{{item.phon}}</span>
                    <span v-for="(item,index) in itemsSyll[present].split_phons" v-if="!isPho" :style="item.color == 'red' ?'color:#C55151':''">{{item.phon}}</span>
                    <span>]</span>
                    <img src="../../src/assets/payAudio.png" mode=""/>
                </div>
                <div class="teBy">
                    <span v-if="itemsSyll[present].pos">{{itemsSyll[present].pos}}.</span>
                    <span>{{itemsSyll[present].translation}}</span>
                </div>
                <div class="flexboxItme">
                    <div :class="!isPho && itemsSyll[present].phonics ?'chaiBox avtives':'chaiBox'" @click="chaiBox" >拆分发音</div>
                    <div :class="isPho ?'ziran avtives':'ziran'" @click="ziran" v-if="itemsSyll[present].phonics">自然拼读</div>
                </div>
                <div class="flexTop" >
                    <div class="infos" style="margin-top: 10px;width:100%;text-align: center; color: #8A8D90" v-if="!isPho">
                        可点读
                        <RadioGroup v-model="animalRadio" size="large">
                            <Radio label="1" size="large" style="font-size: 20px;margin-left: 30px;">点读</Radio>
                            <Radio label="2" size="large" style="font-size: 20px;margin-left: 10px;">连读</Radio>
                        </RadioGroup>
                    </div>
                    <div :class="worIndex === index?'wordTop activesWord':'wordTop'" v-for="(item,index) in itemsSyll[present].split_phons" :key="index" v-if="!isPho">
                        <div class="itemList" @click="itemList1(item,index)" :style="item.color == 'red' ?'color:#C55151':''">{{item.chars}}</div>
                        <div class="itemList1" @click="itemList1(item,index)" v-if="item.phon">/<span :style="item.color == 'red' ?'color:#C55151':''">{{item.phon}}</span> /</div>
                        <div class="itemList1"  v-if="!item.phon">-</div>
                    </div>
                    <div :class="worIndex === index?'wordTop activesWord':'wordTop'" v-for="(item,index) in itemsSyll[present].phonics" :key="index" v-if="isPho">
                        <div class="itemList" :style="item.color == 'red' ?'color:#C55151':''">{{item.chars}}</div>
                        <div class="itemList1" v-if="item.phon">/<span :style="item.color == 'red' ?'color:#C55151':''">{{item.phon}}</span> /</div>
                        <div class="itemList1"  v-if="!item.phon">-</div>
                    </div>
                </div>
                <div class="imagePay" v-if="payaimg">
                    <img :src="payaimg" mode=""/>
                </div>
            </div>
            <div class="contBoxList">
                <div class="startBtn" @click="proSubject" ><Icon type="md-arrow-dropup" style="margin-top:-4px" size="30" />上一个</div>
                <div class="startBtn" @click="nextSubJect"><Icon type="md-arrow-dropdown" size="30" />下一个</div>
               
                <div class="startBtn" @click="gohome">回到列表页</div>
            </div>
        </div>
        
        <audio ref="audio" controls="controls" class="audiosBox" @ended="overAudio"></audio>
        <div class="payVipBox" v-if="!is_payed">
            <div class="PayBoxs">
                <div class="payTitle">提示</div>
                <div class="infosBox">开通会员后即可使用小程序全部功能(包含投屏默写)</div>
                <div class="payMage">
                    <img src="../assets/pay.png"></img>
                </div>
                <div class="buttonTitle">扫码立即开通永久会员</div>
            </div>
            <Button type="primary" class="goback poson" @click="goHome"><Icon type="md-exit" />返回列表</Button>
        </div>
    </div>
</template>
  
  <script>
import axios from "axios";
import qs from "qs"
import ASEUrl from "../cryptojs/secret"
import ENAudio from "../cryptojs/enAudio"
export default {
    data() {
      return {
        id:'',
        is_payed:false,
        newArray:[],
        present:0,
        wordlist:[],
        itemsSyll:[
            {
                split_phons:[]
            }
        ],
        isPho:false,
        wordUrl:'https://cdn.bjwxjs.com/emi/file?ticket=admin',
        payaimg:'',
        payPhonAudio:'',
        worIndex:'' ,
        animalRadio:'1'
       
      };
    },
     watch: {
     
        
 },
    created() {
        this.ENAudio = ENAudio
    },
    mounted() {
        this.id = this.$route.query.id
        // this.showType = this.$route.query.showType
        if(this.$route.query.type){
            this.queryScreenWordList()
        }else{
            this.queryWordList()

        }
        this.isQueryVip()
       
    },
    methods: {
        isQueryVip(){
        var that = this
        axios({
            headers:{
               'Content-Type':'application/x-www-form-urlencoded',
                'Authorization': window.localStorage.getItem('sessionId'),
            },
            method: 'GET',
            url: '/v1/user/perm',
            })
            .then((res) => {
                if (typeof res.data === 'string') {
              res.data = JSON.parse(ASEUrl.decrypted(res.data)) 
            } 
                    that.is_payed = res.data.data.is_payed
                })
            .catch((err) => {
                that.$Message.error(err);
            });
        },
        wordYb(){
            let that = this
            let item =  this.itemsSyll[this.present]
            that.$refs.audio.src = encodeURI(that.wordUrl+'&word='+item.word)
            that.$refs.audio.play()

        },
        proSubject(e){
            if(this.present == 0){
                this.$Message.warning('当前已经是第一题');
               
            }else{
                this.present = this.present-1
                this.worIndex='' 
            }
            
        },
        nextSubJect(e){
            if(this.itemsSyll.length == this.present+1){
                this.$Message.warning('当前已经是最后一题');
            }else{
                this.present = this.present+1
                this.worIndex='' 
            }

        },
        overAudio(){
            let that = this
            if(this.animalRadio == 2){
                if(this.animalRadio == 2){
                    if(this.itemsSyll[this.present].split_phons.length-1 == this.worIndex){
                        let item =  this.itemsSyll[this.present]
                        that.$refs.audio.src = encodeURI(that.wordUrl+'&word='+item.word)
                        that.$refs.audio.play()
                        this.worIndex = this.worIndex+1
                        console.log(1)
                    }else if(this.itemsSyll[this.present].split_phons.length-1 < this.worIndex){
                        this.worIndex = ''
                        console.log(2)
                        return false
                    }else{
                        console.log(3)
                        this.worIndex = this.worIndex+1
                        let that = this
                        setTimeout(() => {
                                that.itemList1(this.itemsSyll[this.present].split_phons[this.worIndex],this.worIndex)
                        }, 500);
                    }
                
                }
            }
            
        },

        itemList1(item,index){
            let phon = item.phon || ''
            let ENAudio = this.ENAudio.AudioList || ''
            let worIndex = index || 0
            let payaimg = ''
            let payPhonAudio = ''
            payPhonAudio=''
            payaimg = ''
            ENAudio.map(item=>{
                if(item.zi == phon){
                    payaimg = item.image
                    payPhonAudio = item.audio
                }
            })
            this.payaimg=payaimg,
            console.log(this.payaimg)
            this.payPhonAudio=payPhonAudio,
            this.worIndex=Number(worIndex) 
            this.$refs.audio.src = payPhonAudio
            this.$refs.audio.play()
        },
        chaiBox(){
            this.isPho=false
        },
        ziran(){
            this.isPho=true,
            this.worIndex=''
        },
        queryWordList(){
            const that = this
            axios({
            headers:{
                'Content-Type':'application/x-www-form-urlencoded',
                'Authorization': window.localStorage.getItem('sessionId')
            },
            method: 'get',
            url: '/v1/dict/phonics/'+this.id,
            data:{}
            })
            .then((res) => {
                if (typeof res.data === 'string') {
              res.data = JSON.parse(ASEUrl.decrypted(res.data)) 
              console.log(res.data)
            } 
                if(res.data.code == 0){
                  let list1 = res.data.data.words
                    list1.map(item=>{
                        item.phonics.map(item1=>{
                            if(item1.chars.indexOf('a')>-1 || item1.chars.indexOf('e')>-1 ||item1.chars.indexOf('i')>-1 ||item1.chars.indexOf('o')>-1 ||item1.chars.indexOf('u')>-1){
                            item1.color='red'
                            }else{
                            item1.color='blue'
                            }
                        })
                        item.split_phons.map(item1=>{
                        if(item1.chars.indexOf('a')>-1 || item1.chars.indexOf('e')>-1 ||item1.chars.indexOf('i')>-1 ||item1.chars.indexOf('o')>-1 ||item1.chars.indexOf('u')>-1){
                            item1.color='red'
                        }else{
                            item1.color='blue'
                        }
                        item1.phon = item1.phon.replace(/ˈ/g, '');
                        item1.phonRem = item1.phon.replace(/$$[^)]*$$/g, '').replace(/ˈ/g, '');
                        })
                    })
                    console.log(list1)

                    this.itemsSyll = JSON.parse(JSON.stringify(list1))
                }else{
                    if(res.data.code == 4001){
                        this.$router.push('login')
                    }else{
                        that.$Message.error(res.data.msg);

                    }
                }
                })
            .catch((err) => {
                that.$Message.error(err);
            });
        },
        queryScreenWordList(){
        const that = this
        axios({
          headers:{
            'Content-Type':'application/x-www-form-urlencoded',
           'Authorization': window.localStorage.getItem('sessionId'),
          },
          method: 'GET',
          url: '/v1/screen/phonics/'+this.id,
          data:{}                                                                                             
          })                     
        .then((res) => {
            if (typeof res.data === 'string') {
              res.data = JSON.parse(ASEUrl.decrypted(res.data)) 
            } 
            if(res.data.code == 0){
                  let list1 = res.data.data.words
                    list1.map(item=>{
                        item.phonics.map(item1=>{
                            if(item1.chars.indexOf('a')>-1 || item1.chars.indexOf('e')>-1 ||item1.chars.indexOf('i')>-1 ||item1.chars.indexOf('o')>-1 ||item1.chars.indexOf('u')>-1){
                            item1.color='red'
                            }else{
                            item1.color='blue'
                            }
                        })
                       
                        item.split_phons.map(item1=>{
                        if(item1.chars.indexOf('a')>-1 || item1.chars.indexOf('e')>-1 ||item1.chars.indexOf('i')>-1 ||item1.chars.indexOf('o')>-1 ||item1.chars.indexOf('u')>-1){
                            item1.color='red'
                        }else{
                            item1.color='blue'
                        }
                        item1.phon = item1.phon.replace(/ˈ/g, '');
                        item1.phonRem = item1.phon.replace(/$$[^)]*$$/g, '').replace(/ˈ/g, '');
                        })
                    })
                    console.log(list1)

                    this.itemsSyll = JSON.parse(JSON.stringify(list1))
                }else{
                    if(res.data.code == 4001){
                        this.$router.push('login')
                    }else{
                        that.$Message.error(res.data.msg);

                    }
                }
            })
        .catch((err) => {
            that.$Message.error(err);
        });
      },
        gohome(){
            this.$router.push('topicList');
        },
        querySplit(words,list1){
            axios({
                headers: {
                  'Content-Type': 'application/json',
                  'Authorization': window.localStorage.getItem('sessionId')
                },
                method: 'POST',
                url: '/v1/word/phonics',
                data: {
                  words :words,
                }
              })
              .then((res) => {
                if (typeof res.data === 'string') {
              res.data = JSON.parse(ASEUrl.decrypted(res.data)) 
            } 
                if(res.data.code == 0){
                    console.log(res.data)
                  

                }else{
                  that.$Message.error(res.data.msg);
                }
              })
              .catch((err) => {
              });

        },

       

        goHome(){
            this.$router.push({name:'topicList'})
        },
     
      
    },

  };
  </script>
  <style scoped>
    .loginBG{
        width: 100%;
        height: 100%;
        background: url('https://r.bjwxjs.com/PC_kpy/enPageBackgroundPage.png') 0 0 / 100% 100% no-repeat;
        position: fixed;
        top: 0;
        left: 0;
        bottom: 0;
        right: 0;
    }
    .contentbox{
        padding:50px;
        box-sizing: border-box;
        height: 100%;
        margin:0 auto;
        width: 100%;
    }
    .wordSyBox{
        position: relative;
        padding-top: 60px;
    }
    .Words{
        text-align: center;
        font-size: 100px;
        font-weight: 600;
        color:#057DFF ;
    }
    .wordYb{
        /* background: #F6EAD3; */
        border-radius: 12px;
        margin: 0 auto 50px;
        font-size: 40px;
        line-height: 97px;
        text-align: center;
        color: #057DFF;
        font-weight: 600;
    }
    .wordYb img{
        width: 50px;
        height: 50px;
        vertical-align: -12px;
        margin-left: 15px;
    }
    .teBy{
        font-family: PingFangSC, PingFang SC;
        font-weight: 600;
        font-size: 50px;
        color: #8A8D90;
        text-align: center;
    }
    .flexTop{
        display: flex;
        flex-wrap: wrap;
        justify-content: center;
        margin: 0 auto;
        padding: 0 16px;
        box-sizing: border-box;
        border-top: 4px solid #DFDFDF;
        position: relative;
    }
    .flexDbox{
        position: absolute;
        right: 0;
        top: 10px;
    }
    .wordTop{
        margin-top: 30px;
        border:4px solid  rgba(0, 0, 0, .12);
        margin-right: 12px;
        border-radius: 15px;
        box-sizing: border-box;
    }
    .activeWord{
        border:2px solid#E28000;
    }

.titleItem{
  font-size: 36px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #303133;
  width: 100%;
  padding: 0 30px;
  box-sizing: border-box;
  background-color: #F9F9F9;
  height: 100px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  z-index: 9;
  box-sizing: border-box;
  margin-top: 20px;
}


.itemList{
  min-width: 88px;
  height: 68px;
  background: #F8F6ED;
  border-radius: 15px 15px 0 0;
  font-weight: 600;
  font-size: 32px;
  color: #057DFF;
  line-height: 68px;
  text-align: center;
}
.itemList1{
  min-width: 88px;
  height: 68px;
  background: #F5E9D2;
  font-weight: 600;
  font-size: 32px;
  color: #333;
  line-height: 68px;
  text-align: center;
  margin-top: 2px;
  border-radius: 0 0 15px 15px;
}
.imagePay{
  width: 340px;
  height: 340px;
  margin: 60px auto 0;
}
.imagePay img{
  width: 340px;
  height: 340px;
}
.contBoxList{
    position: fixed;
    right: 90px;
    top: 80px;
}
.startBtn{
    width: 180px;
    height: 60px;
    background: url('https://r.bjwxjs.com/PC_kpy/pc_button_BG@2x.png') 0 0 / 100% 100% no-repeat;
    font-size: 26px;
    font-family: HiraginoSansGB-W6, HiraginoSansGB;
    font-weight: normal;
    color: #207DE5;
    text-align: center;
    line-height: 60px;
    margin-top: 10px;
    margin-left: 10px;
    cursor:pointer;

}
.auto-fade-box{
  animation: fadeLoop 1.2s ease-in-out infinite;
}
@keyframes fadeLoop {
  0% { opacity: 0; }   /* 完全透明 */
  50% { opacity: 1; }  /* 完全显示 */
  100% { opacity: 0; } /* 恢复透明 */
}
.activesWord{
  border: 4px solid #E28000;
  box-sizing: border-box;
}
.infos{
    font-size: 24px;
}
.flexboxItme{
  display: flex;
  width: 500px;
  justify-content: center;
  margin: 40px auto 0;
  height: 74px;
  margin-bottom: 30px;
}
.chaiBox{
  width: 216px;
  height: 74px;
  border-radius: 38px;
  border: 2px solid #E28000;
  text-align: center;
  color:#E28000;
  line-height: 74px;
  font-size: 32px;
  margin-right: 30px;
  cursor: pointer;

}

.ziran{
  width: 216px;
  height: 74px;
  background: #fff;
  border-radius: 38px;
  border: 2px solid #E28000;
  color:#E28000;
  font-size: 32px;
  line-height: 42px;
  text-align: right;
  text-align: center;
  line-height: 74px;
  cursor: pointer;

}
.avtives{
  background: #E28000;
  color: #fff;
}
/deep/ .ivu-radio{
    margin-bottom: 10px !important;
}

  </style>
  